/**
 * PAPPO — Uploads Service
 * Envio de anexos de imagem para o backend (/api/uploads).
 */

import { apiUpload } from './api';

/** Faz upload de uma imagem e devolve a URL do anexo + tipo de mensagem */
export async function uploadImage(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return apiUpload<{ attachment_url: string; message_type: 'image' }>(
    '/uploads',
    formData
  );
}

/** Faz upload de uma nota de voz (blob do MediaRecorder) e devolve a URL + tipo.
 *  O nome define a extensão que o backend usa para validar/classificar (audio). */
export async function uploadAudio(blob: Blob) {
  const formData = new FormData();
  formData.append('file', blob, 'gravacao.webm');
  return apiUpload<{ attachment_url: string; message_type: 'audio' }>(
    '/uploads',
    formData
  );
}

/** Faz upload de um vídeo (gravado no celular ou escolhido no PC/galeria).
 *  O backend valida a extensão/mimetype e o teto de tamanho (vídeo = 50 MB). */
export async function uploadVideo(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return apiUpload<{ attachment_url: string; message_type: 'video' }>(
    '/uploads',
    formData
  );
}
